var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/bs.jpg"),"alt":"You picked the wrong path, fool!"}})]),_c('div',{staticClass:"title"},[_vm._v("404")]),_c('div',{staticClass:"text"},[_vm._v("You picked the wrong path")])])
}]

export { render, staticRenderFns }